<template>
  <div>
    <form role="form" aria-label="form">
      <div class="two-column-form-container prochip-form-container">
        <div class="wd-50">
            <div class="text-control">
                <input
                    type="text"
                    id="firstName"
                    class="text-input flex-fill"
                    v-model.trim="v$.firstName.$model"
                    :class="{
                    'error-text-control':
                        v$.firstName.$errors && v$.firstName.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.firstName)"
                    @blur="v$.firstName.$touch"
                    aria-describedby="firstName-error"
                    aria-required="true"
                    :aria-invalid="v$.firstName.$errors.length > 0"
                    title="Please fill in the firstName"
                />
                <label
                    for="firstName"
                    class="text-label"
                    :class="{
                    'error-label': v$.firstName.$errors && v$.firstName.$errors.length > 0,
                    }"
                    >First Name</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="firstName-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.firstName.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>

        <div class="wd-45">
          <div class="text-control">
                <input
                    type="text"
                    id="lastName"
                    class="text-input flex-fill"
                    v-model.trim="v$.lastName.$model"
                    :class="{
                    'error-text-control':
                        v$.lastName.$errors && v$.lastName.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.lastName)"
                    @blur="v$.lastName.$touch"
                    aria-describedby="lastName-error"
                    aria-required="true"
                    :aria-invalid="v$.lastName.$errors.length > 0"
                    title="Please fill in the lastName"
                />
                <label
                    for="lastName"
                    class="text-label"
                    :class="{
                    'error-label': v$.lastName.$errors && v$.lastName.$errors.length > 0,
                    }"
                    >Last Name</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="lastName-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.lastName.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>
      </div>
      <!--  -->
      <div class="two-column-form-container">
        <div class="wd-50">
            <div class="text-control">
                <input
                    type="text"
                    id="emailAddress"
                    class="text-input flex-fill"
                    v-model.trim="v$.emailAddress.$model"
                    :class="{
                    'error-text-control':
                        v$.emailAddress.$errors && v$.emailAddress.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.emailAddress)"
                    @blur="v$.emailAddress.$touch"
                    aria-describedby="emailAddress-error"
                    aria-required="true"
                    :aria-invalid="v$.emailAddress.$errors.length > 0"
                    title="Please fill in the emailAddress"
                    disabled
                />
                <label
                    for="emailAddress"
                    class="text-label"
                    :class="{
                    'error-label': v$.emailAddress.$errors && v$.emailAddress.$errors.length > 0,
                    }"
                    >Email Address</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="emailAddress-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.emailAddress.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>

        <div class="wd-45">
          <div class="text-control">
                <input
                    type="text"
                    id="company"
                    class="text-input flex-fill"
                    v-model.trim="v$.company.$model"
                    :class="{
                    'error-text-control':
                        v$.company.$errors && v$.company.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.company)"
                    @blur="v$.company.$touch"
                    aria-describedby="company-error"
                    aria-required="true"
                    :aria-invalid="v$.company.$errors.length > 0"
                    title="Please fill in the company"
                />
                <label
                    for="company"
                    class="text-label"
                    :class="{
                    'error-label': v$.company.$errors && v$.company.$errors.length > 0,
                    }"
                    >Company</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="company-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.company.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>
      </div>
      <!--  -->
      <div class="two-column-form-container">
        <div class="wd-50">
            <div class="text-control">
                <input
                    type="text"
                    id="phone"
                    class="text-input flex-fill"
                    v-model.trim="v$.phone.$model"
                    :class="{
                    'error-text-control':
                        v$.phone.$errors && v$.phone.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.phone)"
                    @blur="v$.phone.$touch"
                    aria-describedby="phone-error"
                    aria-required="true"
                    :aria-invalid="v$.phone.$errors.length > 0"
                    title="Please fill in the phone"
                />
                <label
                    for="phone"
                    class="text-label"
                    :class="{
                    'error-label': v$.phone.$errors && v$.phone.$errors.length > 0,
                    }"
                    >Phone</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="phone-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.phone.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>

        <div class="wd-45">
          <div class="text-control">
                <input
                    type="text"
                    id="address"
                    class="text-input flex-fill"
                    v-model.trim="v$.address.$model"
                    :class="{
                    'error-text-control':
                        v$.address.$errors && v$.address.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.address)"
                    @blur="v$.address.$touch"
                    aria-describedby="address-error"
                    aria-required="true"
                    :aria-invalid="v$.address.$errors.length > 0"
                    title="Please fill in the address"
                />
                <label
                    for="address"
                    class="text-label"
                    :class="{
                    'error-label': v$.address.$errors && v$.address.$errors.length > 0,
                    }"
                    >Address</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="address-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.address.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>
      </div>
      <!--  -->
      <div class="two-column-form-container">
        <div class="wd-50">
            <div class="text-control">
                <input
                    type="text"
                    id="city"
                    class="text-input flex-fill"
                    v-model.trim="v$.city.$model"
                    :class="{
                    'error-text-control':
                        v$.city.$errors && v$.city.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.city)"
                    @blur="v$.city.$touch"
                    aria-describedby="city-error"
                    aria-required="true"
                    :aria-invalid="v$.city.$errors.length > 0"
                    title="Please fill in the city"
                />
                <label
                    for="city"
                    class="text-label"
                    :class="{
                    'error-label': v$.city.$errors && v$.city.$errors.length > 0,
                    }"
                    >City</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="city-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.city.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>

        <div class="wd-45">
          <div class="text-control">
                <input
                    type="text"
                    id="postalCode"
                    class="text-input flex-fill"
                    v-model.trim="v$.postalCode.$model"
                    :class="{
                    'error-text-control':
                        v$.postalCode.$errors && v$.postalCode.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.postalCode)"
                    @blur="v$.postalCode.$touch"
                    aria-describedby="postalCode-error"
                    aria-required="true"
                    :aria-invalid="v$.postalCode.$errors.length > 0"
                    title="Please fill in the postalCode"
                />
                <label
                    for="postalCode"
                    class="text-label"
                    :class="{
                    'error-label': v$.postalCode.$errors && v$.postalCode.$errors.length > 0,
                    }"
                    >Postal code</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="postalCode-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.postalCode.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>
      </div>
      <!--  -->
      <div class="two-column-form-container">
        <div class="wd-50">
            <div class="text-control">
                <input
                    type="text"
                    id="country"
                    class="text-input flex-fill"
                    v-model.trim="v$.country.$model"
                    :class="{
                    'error-text-control':
                        v$.country.$errors && v$.country.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.country)"
                    @blur="v$.country.$touch"
                    aria-describedby="country-error"
                    aria-required="true"
                    :aria-invalid="v$.country.$errors.length > 0"
                    title="Please fill in the country"
                />
                <label
                    for="country"
                    class="text-label"
                    :class="{
                    'error-label': v$.country.$errors && v$.country.$errors.length > 0,
                    }"
                    >Country</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="country-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.country.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>

        <div class="wd-45">
          <div class="text-control">
                <input
                    type="text"
                    id="state"
                    class="text-input flex-fill"
                    v-model.trim="v$.state.$model"
                    :class="{
                    'error-text-control':
                        v$.state.$errors && v$.state.$errors.length > 0,
                    }"
                    @input="formValueChanged(v$.state)"
                    @blur="v$.state.$touch"
                    aria-describedby="state-error"
                    aria-required="true"
                    :aria-invalid="v$.state.$errors.length > 0"
                    title="Please fill in the state"
                />
                <label
                    for="state"
                    class="text-label"
                    :class="{
                    'error-label': v$.state.$errors && v$.state.$errors.length > 0,
                    }"
                    >State</label
                >
                <span class="required">*</span>
                </div>
                <div class="input-errors" id="state-error" aria-live="assertive" aria-relevant="all">
                <div
                    class="error-msg"
                    v-for="(error, index) of v$.state.$errors"
                    :key="index"
                >
                    {{ error.$message }}
                </div>
            </div>
        </div>
      </div>
      
    </form>
  </div>
</template>

<script>
import { reactive, watch, onMounted, nextTick } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, email, maxLength, minLength, helpers } from "@vuelidate/validators";

// Validation functions (no change here)
export function alphaSpacesRules(word) {
  let validPattern = new RegExp("^([a-zA-Z\\s])*$");
  return validPattern.test(word);
}

export function numberRules(num) {
//   let validNumberPattern = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
    let validNumberPattern = new RegExp(
    /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g
    );
  if (validNumberPattern.test(num)) {
    return true;
  }
  return false;
}

export function isFilled(word) {
  if (word){
    return true;
  }
  return false;
}

export default {
  props: ["userProfileDetails"], // Receive the prop
  emits: ["userDataChanged"],
  setup(props, context) {
    // Initializing form data to match the props
    const form = reactive({
      firstName: props.userProfileDetails.FirstName || "", // props if available, else default to empty
      lastName: props.userProfileDetails.LastName || "",
      emailAddress: props.userProfileDetails.EmailAddress || "",
      company: props.userProfileDetails.CompanyName || "",
      phone: props.userProfileDetails.PhoneNumber || "",
      address: props.userProfileDetails.Address?.AddressLine1 + ', ' + props.userProfileDetails.Address?.AddressLine2 + ', ' + props.userProfileDetails.Address?.AddressLine3 || "",
      city: props.userProfileDetails.Address?.City || "",
      postalCode: props.userProfileDetails.Address?.PostalCode || "",
      country: props.userProfileDetails.Address?.Country?.Name || "",
      state: props.userProfileDetails.Address?.State?.Name  || "",
    });

    
    
    const phoneRegex = /^(\(\?[0-9]*\)?)?[0-9_\- x()]*$/
  // const validPhone = (value) => phoneRegex.test(value || '')
  const validPhone = helpers.withMessage(
      'Invalid phone number format.',
      value => phoneRegex.test(value || '')
    )

  // 1. DefaultLength: Max 50 characters
  const defaultLengthRegex = helpers.withMessage(
    'Please enter less than 50 characters.',
    value => /^.{0,50}$/.test(value || '')
  )

  // 2. NoNumbersOnly: Prevent only numbers and spaces
  const noNumbersOnlyRegex = helpers.withMessage(
    'Numbers only are not allowed.',
    value => /^(?![\d\s]+$).*$/.test(value || '')
  )
 
  // 3. NoSpecialCharOnly: Prevent values made only of numbers and special characters with no letters,
  //    but require at least one special character (so that pure numbers are handled by noNumbersOnlyRegex)
  const noSpecialCharOnlyRegex = helpers.withMessage(
    'Please include at least one letter; an entry cannot consist only of special characters.',
    value => {
      const v = value || ''
      // If empty, let required/other rules handle it
      if (!v) return true

      const hasLetter = /[A-Za-z]/.test(v)
      const hasSpecial = /[^0-9\sA-Za-z]/.test(v)

      // Invalid when there is at least one special character and no letters
      return !(hasSpecial && !hasLetter)
    }
  )

    const rules = {
      firstName: {
        required: helpers.withMessage('Value is required.', required),
        //minLength: helpers.withMessage('This field should be at least 2 characters long', minLength(2)),
        defaultLengthRegex,
        noNumbersOnlyRegex,
        noSpecialCharOnlyRegex,
      },
      lastName: {
        required: helpers.withMessage('Value is required.', required),
        //minLength: helpers.withMessage('This field should be at least 1 character long', minLength(1)),
        defaultLengthRegex,
        noNumbersOnlyRegex,
        noSpecialCharOnlyRegex,
      },
      emailAddress: {
        required: helpers.withMessage('Email is required.', required),
        email: helpers.withMessage('Please enter a valid email address.', email),
      },
      company: {
        required: helpers.withMessage('Company Name is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 50', maxLength(50)),
      },
      phone: {
        required: helpers.withMessage('Phone is required.', required),
        validPhone,
        minLength: helpers.withMessage('Must have at least 10 characters.', minLength(10)),
        maxLength: helpers.withMessage('Must have at most 25 characters.', maxLength(25)),
      },
      address: {
        required: helpers.withMessage('Address is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 50', maxLength(50)),
      },
      city: {
        required: helpers.withMessage('City Name is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 50', maxLength(50)),
      },
      postalCode: {
        required: helpers.withMessage('Postal code is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 10', maxLength(10)),
      },
      country: {
        required: helpers.withMessage('Country is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 50', maxLength(50)),
      },
      state: {
        required: helpers.withMessage('State is required.', required),
        minLength: helpers.withMessage('This field should be at least 3 characters long', minLength(3)),
        maxLength: helpers.withMessage('The maximum length allowed is 50', maxLength(50)),
      },
    };


    const v$ = useVuelidate(rules, form);

    // Emit data change on form value update
    function formValueChanged(ref) {
      ref.$touch();
      context.emit("userDataChanged", {
        firstName: form.firstName,
        lastName: form.lastName,
        emailAddress: form.emailAddress,
        company: form.company,
        phone: form.phone,
        address: form.address,
        city: form.city,
        postalCode: form.postalCode,
        country: form.country,
        state: form.state,
        isFormInvalid:
          v$._value.$errors.length > 0 || v$._value.$silentErrors.length > 0,
      });
    }
    
    
    // Watch for prop updates and trigger validation
    watch(() => props.userProfileDetails, (newProfile) => {
      // Update form values with new profile data
    //   form.firstName = newProfile.FirstName || '';
      form.firstName = (newProfile.FirstName || '').trim();
    //   form.lastName = newProfile.LastName || '';
      form.lastName = (newProfile.LastName || '').trim();
      form.emailAddress = newProfile.EmailAddress || '';
    //   form.company = newProfile.CompanyName || '';
      form.company = (newProfile.CompanyName || '').trim();
    //   form.phone = newProfile.PhoneNumber || '';
    form.phone = (newProfile.PhoneNumber || '').trim();
      form.address = (newProfile.Address?.AddressLine1 || '').trim();
    //   form.city = newProfile.Address?.City || '';
      form.city = (newProfile.Address?.City || '').trim();
    //   form.postalCode = newProfile.Address?.PostalCode || '';
     form.postalCode = (newProfile.Address?.PostalCode || '').trim();
      form.country = (newProfile.Address?.Country?.Name || '').trim();
    //   form.state = newProfile.Address?.State?.Name || '';
    form.state = (newProfile.Address?.State?.Name || '').trim();

      // Wait for the next DOM update cycle to ensure that values are updated
      nextTick(() => {
        // Trigger validation immediately after the prop change
        if (v$) {
          // Mark fields as dirty only if they exist in v$
          Object.keys(form).forEach(field => {
            if (v$[field]) {
              // v$[field].$setDirty();  // Mark fields as dirty to trigger validation
              v$.value.$touch();
            }
          });

          // Manually validate all fields
          Object.keys(v$).forEach(field => {
            if (v$[field] && typeof v$[field].$validate === 'function') {
              v$[field].$validate();  // Validate each field manually
            }
          });
          context.emit("userDataChanged", {
            ...form,
            isFormInvalid:
                v$._value.$errors.length > 0 || v$._value.$silentErrors.length > 0,
            });
        }
      });
    }, { immediate: true }); // Ensure the watch is triggered immediately on prop change


    
    // Trigger validation when the component is mounted
    onMounted(() => {
      nextTick(() => {
        if (v$) {
          try {
            // Safely touch each field to trigger validation
            if (v$.firstName) v$.firstName.$touch();
            if (v$.lastName) v$.lastName.$touch();
            if (v$.emailAddress) v$.emailAddress.$touch();
            if (v$.company) v$.company.$touch();
            if (v$.phone) v$.phone.$touch();
            if (v$.address) v$.address.$touch();
            if (v$.city) v$.city.$touch();
            if (v$.postalCode) v$.postalCode.$touch();
            if (v$.country) v$.country.$touch();
            if (v$.state) v$.state.$touch();
          } catch (error) {
            console.error("Error triggering validation:", error);
          }
        }
      });
    });
    

    return {
      form,
      v$,
      formValueChanged
    };
  }
};
</script>